import React from 'react'
import styled, { css } from 'styled-components'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

import phoneMockImg from '@/images/phone-mock/phone_mock.png'

import { mobile } from '../../../utils/media-query'
import { phoneImages } from '../carousel/slide-data'

const PhoneGraphic = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  position: relative;

  ${mobile.css`
        position: relative;
        clip-path: inset(-16% 0% 0% 0%);
        width: 100%;
        display: flex;
        justify-content: center;
    `}
`

const BaseImageContainer = styled.div`
  position: absolute;
  transform: translateY(-17%);
  overflow: hidden;

  ${mobile.css`
        width: 100%;
        display: flex;
        justify-content: center;
    `}
`

const BasePhoneImg = styled.img``

type ImageSlideProps = {
  isLastSlide: boolean
}
const ImageSlide = styled.div<ImageSlideProps>`
  position: absolute;
  top: 40px;
  height: 100%;
  overflow: hidden;
  border-bottom-left-radius: 37px;
  border-bottom-right-radius: 37px;
  /* adding this mask-image style so that the overflow and border-radius styles work together in safari */
  mask-image: radial-gradient(white, black);
  transition: top 300ms ease-in-out 300ms, height 300ms ease-in-out 300ms;

  ${({ isLastSlide }) =>
    isLastSlide &&
    css`
      top: -7px;
      height: 567px;
    `}

  ${mobile.css`
        left: unset;
        top: 0.1%;
        border-radius: 0;
    `}
`

const Images = styled.div`
  width: 278px;
  position: relative;
  height: 100%;
  top: 100%;
`

const Image = styled.img`
  width: 100%;
  position: absolute;
  top: 0;
  transform: translateY(-100%);

  &.slide.enter {
    transform: translateY(0%);
  }

  &.slide.enter-active {
    transform: translateY(-100%);
    transition: transform 300ms ease-in-out 300ms;
  }

  &.slide.exit {
    transform: translateY(-100%);
  }

  &.slide.exit-active {
    transform: translateY(0%);
    transition: transform 300ms ease-in-out;
  }
`

type PhoneProps = {
  theme: string
  orientation: string
  currentSlideIndex: number
}

const Phone = ({ theme, orientation, currentSlideIndex }: PhoneProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = phoneImages[currentSlideIndex] as any
  const imgSrc =
    currentSlideIndex === 0 ? data[theme.toLowerCase()][orientation.toLowerCase()] : data.src

  return (
    <PhoneGraphic>
      <BaseImageContainer>
        <BasePhoneImg src={phoneMockImg} />
      </BaseImageContainer>
      <ImageSlide isLastSlide={currentSlideIndex === 2}>
        <Images>
          <TransitionGroup component={null}>
            <CSSTransition key={imgSrc} className="slide" timeout={600}>
              <Image src={imgSrc} />
            </CSSTransition>
          </TransitionGroup>
        </Images>
      </ImageSlide>
    </PhoneGraphic>
  )
}

export default Phone
